(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-base-price]').forEach((purchase) => {
      if (purchase.dataset.menopausePurchaseReady === 'true') return;
      purchase.dataset.menopausePurchaseReady = 'true';

      const price = purchase.querySelector('[data-package-price]');
      const comparePrice = purchase.querySelector('[data-package-compare-price]');
      const property = purchase.querySelector('[data-abo-property]');
      const saving = purchase.querySelector('[data-package-saving]');

      const updatePrice = () => {
        const selected = purchase.querySelector('.nc-abo-selector input:checked');
        const basePrice = Number(purchase.dataset.basePrice || 0);
        const discount = Number(selected?.dataset.discount || 0);
        const nextPrice = Math.round((basePrice * (100 - discount)) / 100);
        const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

        if (price) price.textContent = formatter.format(nextPrice / 100);
        if (comparePrice) {
          comparePrice.textContent = formatter.format(basePrice / 100);
          comparePrice.hidden = discount === 0;
        }
        if (property) property.value = selected?.dataset.aboLabel || selected?.value || '';
        if (saving) {
          saving.textContent = discount > 0
            ? `Mit ${selected.value} sparst du ${discount}% auf den Testpreis.`
            : 'Mit Free zahlst du den regulären Testpreis – ohne monatliche App-Kosten.';
        }
      };

      purchase.querySelectorAll('.nc-abo-selector input').forEach((input) => {
        input.addEventListener('change', updatePrice);
      });
      updatePrice();
    });

    scope.querySelectorAll('[data-menopause-gallery]').forEach((gallery) => {
      const mainImage = gallery.querySelector('[data-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      if (!mainImage || !thumbs.length) return;
      gallery.dataset.menopauseGalleryReady = 'true';
    });
  };

  const showGalleryImage = (gallery, index) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImage || !thumbs.length) return;

    const normalizedIndex = (index + thumbs.length) % thumbs.length;
    const activeThumb = thumbs[normalizedIndex];
    mainImage.src = activeThumb.dataset.gallerySrc;
    mainImage.alt = activeThumb.dataset.galleryAlt || '';
    thumbs.forEach((item, itemIndex) => {
      const isActive = itemIndex === normalizedIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-gallery-thumb], [data-gallery-stage], [data-gallery-prev], [data-gallery-next]');
    if (!control) return;

    const gallery = control.closest('[data-menopause-gallery]');
    if (!gallery) return;

    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let nextIndex = activeIndex;

    if (control.matches('[data-gallery-thumb]')) nextIndex = thumbs.indexOf(control);
    if (control.matches('[data-gallery-stage], [data-gallery-next]')) nextIndex = activeIndex + 1;
    if (control.matches('[data-gallery-prev]')) nextIndex = activeIndex - 1;

    showGalleryImage(gallery, nextIndex);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
